<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>사용자 리스트</h2>
      </div>
      <div class="table-btn center-right">
        <div class="btn-frige-register" @click="createUser">
          <button class="btn btn-140"><span><img src="/static/img/ico-plus-white@2x.png" alt=""></span>사용자 등록</button>
        </div>
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <!-- <div class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40"><span><img src="/static/img/ico_excel@2x.png" alt=""></span></button>
        </div> -->
      </div>
    </div>
    <div class="table-desc">
      <table>
        <tr class="header">
          <th>사용자 ID</th>
          <th>사용자 이름</th>
          <th>역할</th>
          <th>회사 ID</th>
          <th>회사 이름</th>
          <th>부서 ID</th>
          <th>부서 이름</th>
        </tr>

        <tbody v-if="loading === false && userList.length > 0">
          <tr v-for="item in userList" :key="item.uID" @click="goDetail(item)">
            <td>
              <div>{{ item.userID }}</div>
            </td>
            <td>
              <div>{{ item.name }}</div>
            </td>
            <td>
              <div>{{ $getConstName('userRole', item.role) }}</div>
            </td>
            <td>
              <!-- TODO <div>{{ item.companyAlias }}</div> -->
              <div>{{ item.companyID }}</div>
            </td>
            <td>
              <div>{{ item.companyName }}</div>
            </td>
            <td>
              <!-- TODO <div>{{ item.divisionAlias }}</div> -->
              <div>{{ item.divisionID }}</div>
            </td>
            <td>
              <div>{{ item.divisionName }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7">등록된 사용자가 없습니다.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';

export default {
  props: [
    'searchCondition',
    'searchEvent',
    'startTime',
    'endTime',
    'companyID',
    'companyName',
    'companyAlias',
    'divisionID',
    'divisionName',
    'divisionAlias',
  ],
  data: () => ({
    userList: [],
    sum: null,
    pagination: {
      page: 1,
      total: 0,
      length: 1,
      perPage: 10,
      perLength: 5,
      pageArray: [],
      input: 1,
    },
    loading: true,
    companyScope: null,
  }),
  created() {
    this.loadPagination();
    this.getCompanyData();
    this.getUserList();
  },
  watch: {
    searchEvent() {
      this.getCompanyData();

      this.pagination.page = 1;
      this.pagination.input = 1;
      this.pagination.total = 0;
      this.pagination.length = 1;
      this.getUserList();
    },
  },
  methods: {
    refreshList() {
      this.getUserList();
    },
    savePagination() {
      const page = {
        user: this.pagination.page,
      };
      sessionStorage.setItem('pagination', JSON.stringify(page));
    },
    loadPagination() {
      const page = JSON.parse(sessionStorage.getItem('pagination'));
      if (page !== null && page.user !== undefined) this.pagination.page = page.user;
    },
    async getCompanyData() {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${this.companyID}?withDivisions=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.status !== 200) {
          if (response.status === 204) {
            return;
          }

          throw new Error(`response status is "${response.status}"`);
        }
        if (response.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${response.data.resultCode}"`);
        }
        this.companyScope = response.data.company.scope;
      } catch (e) {
        console.error(e);
      }
    },
    async getUserList() {
      this.savePagination();
      this.userList = [];

      try {
        const userList = [];

        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/division/${this.divisionID}?withUsers=true`;

        const list = await this.$http.get(url, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          if (list.status === 204) {
            this.loading = false;
            return;
          }

          throw new Error(`response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${list.data.resultCode}"`);
        }

        if (list.data.division.users) {
          for (let i = 0; i < list.data.division.users.length; i++) {
            const p = list.data.division.users[i];
            const user = {
              uID: p.uID,
              userID: p.userID,
              name: p.name,
              email: p.email,
              mobile: p.mobile,
              role: p.role,
              companyID: this.companyID,
              companyName: this.companyName,
              companyAlias: this.companyAlias,
              divisionID: this.divisionID,
              divisionName: this.divisionName,
              divisionAlias: this.divisionAlias,
              // LastLoginAt: this.$moment(p.LastLoginAt).format('YYYY.MM.DD'),
            };
            userList.push(user);
          }

          this.userList = userList;
        }
        this.loading = false;
      } catch (e) {
        this.userList = [];
        this.loading = false;
        console.error(e);
      }
    },
    /*
    async getUserList() {
      this.userList = [];
      this.pagination.input = this.pagination.page;
      this.loading = true;

      try {
        let countURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/user/count?divisionID=${this.divisionID}`;
        if (this.searchCondition) {
          countURL += `&${this.searchCondition}`;
        }
        const count = await this.$http.get(countURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (count.status !== 200) {
          throw new Error(`Response status is "${count.status}"`);
        }
        if (count.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${count.data.resultCode}"`);
        }
        if (count.data.count < 1) {
          this.pagination.page = 1;
          this.pagination.total = 0;
          this.pagination.length = 1;
          this.loading = false;
          return;
        }

        this.pagination.total = count.data.count;
        this.pagination.length = Math.ceil(
          this.pagination.total / this.pagination.perPage,
        );

        const pageBack = Math.floor((this.pagination.perLength - 1) / 2);
        const pageForward = this.pagination.perLength - 1 - pageBack;
        let firstPage = this.pagination.page - pageForward;
        let lastPage = this.pagination.page + pageBack;
        if (firstPage < 1) {
          firstPage = 1;
          lastPage = this.pagination.perLength;
        }
        if (lastPage > this.pagination.length) {
          lastPage = this.pagination.length;
        }
        if (lastPage - firstPage + 1 < this.pagination.perLength) {
          if (firstPage > 1) {
            firstPage -= this.pagination.perLength - lastPage + firstPage - 1;
            if (firstPage < 1) {
              firstPage = 1;
            }
          } else if (lastPage < this.pagination.length) {
            lastPage += this.pagination.perLength - lastPage + firstPage - 1;
            if (lastPage > this.pagination.length) {
              lastPage = this.pagination.length;
            }
          }
        }

        this.pagination.pageArray = [];
        for (let i = firstPage; i <= lastPage; i++) {
          this.pagination.pageArray.push(i);
        }

        let num =
          this.pagination.total -
          (this.pagination.page - 1) * this.pagination.perPage;
        const userList = [];

        let listURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/user/list?divisionID=${this.divisionID}&page=${this.pagination.page}&limit=${
          this.pagination.perPage
        }`;
        if (this.searchCondition) {
          listURL += `&${this.searchCondition}`;
        }
        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          if (list.status === 204) {
            this.pagination.page = 1;
            this.pagination.total = 0;
            this.pagination.length = 1;
            this.loading = false;
            return;
          }

          throw new Error(`response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${list.data.resultCode}"`);
        }

        for (let i = 0; i < list.data.users.length; i++) {
          const p = list.data.users[i];
          const user = {
            uID: p.uID,
            userID: p.userID,
            name: p.name,
            role: p.role,
            companyID: this.companyID,
            companyName: this.companyName,
            divisionID: this.divisionID,
            divisionName: this.divisionName,
            LastLoginAt: this.$moment(p.LastLoginAt).format('YYYY.MM.DD'),
          };
          userList.push(user);

          num--;
        }

        this.userList = userList;
        this.loading = false;
      } catch (e) {
        this.pagination.page = 1;
        this.pagination.total = 0;
        this.pagination.length = 1;
        this.userList = [];
        this.loading = false;
        console.error(e);
      }
    },
    goPrev() {
      if (this.pagination.page <= 1) {
        return;
      }
      this.pagination.page--;

      this.getUserList();
    },
    goNext() {
      if (this.pagination.page >= this.pagination.length) {
        return;
      }
      this.pagination.page++;

      this.getUserList();
    },
    jumpPrev() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[0];
        this.pagination.page--;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page < 1) {
        this.pagination.page = 1;
      }

      this.getUserList();
    },
    jumpNext() {
      if (
        Array.isArray(this.pagination.pageArray) &&
        this.pagination.pageArray.length > 0
      ) {
        this.pagination.page = this.pagination.pageArray[
          this.pagination.pageArray.length - 1
        ];
        this.pagination.page++;
      } else {
        this.pagination.page = 1;
      }

      if (this.pagination.page > this.pagination.length) {
        this.pagination.page = this.pagination.length;
      }

      this.getUserList();
    },
    goPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page > this.pagination.length) {
        page = this.pagination.length;
      }
      this.pagination.page = page;
      this.getUserList();
    },
    */
    goDetail(user) {
      const division = {
        companyID: this.companyID,
        companyName: this.companyName,
        companyAlias: this.companyAlias,
        scope: this.companyScope,
        divisionID: this.divisionID,
        divisionName: this.divisionName,
        divisionAlias: this.divisionAlias,
      };
      this.$emit('userDetail', user, division);
    },
    createUser() {
      const division = {
        companyID: this.companyID,
        companyName: this.companyName,
        companyAlias: this.companyAlias,
        scope: this.companyScope,
        divisionID: this.divisionID,
        divisionName: this.divisionName,
        divisionAlias: this.divisionAlias,
      };
      this.$emit('userCreate', division);
    },
    downloadExcel() {},
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/user/UserList.vue